import {t} from 'i18next';
import {Dropdown} from 'primereact/dropdown';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

class InputDropdownComponent extends Component {
    renderView() {
        const {
            children,
            colClass,
            enumMode,
            enumName,
            id,
            insideTable,
            label,
            optionLabel,
            renderValue,
            showLabel,
            value,
            valueView,
            validateViewMode,
            validator,
            validators,
            t,
        } = this.props;
        let displayValue = '';
        if (valueView) {
            displayValue = valueView;
        } else if (enumMode && enumName && value && (value instanceof String || typeof value === 'string')) {
            displayValue = t(`${enumName}.${value}`);
        } else if (optionLabel && value && value[optionLabel]) {
            displayValue = value[optionLabel];
        } else if (value && (value instanceof String || typeof value === 'string')) {
            displayValue = value;
        }
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <span aria-label={label} aria-labelledby={`${id}-label-id`} className='p-inputtext-view'>
                            {renderValue ? renderValue() : displayValue}
                        </span>
                        {children ? children() : null}
                        {validateViewMode && validator ? validator.message(id, label, value, validators) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

    renderNew() {
        const {
            appendTo,
            children,
            colClass,
            dataKey,
            disabled,
            enumMode,
            filter,
            filterBy,
            id,
            insideTable,
            itemTemplate,
            label,
            name,
            onAfterStateChange,
            onChange,
            optionLabel,
            optionValue,
            options,
            placeholder,
            showClear,
            showLabel,
            stateField,
            validator,
            validators,
            value,
            valueTemplate,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={children !== undefined ? 'col-md-12 form-group' : 'col-md-12'}>
                        <div className={children !== undefined ? 'row' : 'row'}>
                            <div
                                className={
                                    insideTable ? 'width-100' : children !== undefined ? 'col-8 col-lg-9 col-md-7' : 'col-md-12 form-group'
                                }
                            >
                                {label !== undefined && showLabel ? (
                                    <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                        {validators.includes('not_required') ? (
                                            label
                                        ) : (
                                            <label className='p-label'>
                                                {' '}
                                                {label}
                                                <label className='p-label-red'>{'*'}</label>
                                            </label>
                                        )}
                                    </label>
                                ) : null}
                                <Dropdown
                                    appendTo={appendTo}
                                    aria-describedby={`${id}-error`}
                                    aria-label={label}
                                    aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                                    key={id}
                                    id={id}
                                    emptyMessage={t('global.noResultsFound')}
                                    name={name}
                                    style={{width: '100%'}}
                                    value={value}
                                    options={options}
                                    optionLabel={optionLabel}
                                    optionValue={enumMode ? optionValue : undefined}
                                    dataKey={dataKey}
                                    onChange={(e) =>
                                        onChange ? onChange('DROPDOWN', [optionValue, enumMode], e, onAfterStateChange, stateField) : null
                                    }
                                    placeholder={placeholder}
                                    filter={filter}
                                    filterBy={filterBy}
                                    showClear={showClear}
                                    validator={validator}
                                    validators={validators}
                                    disabled={disabled}
                                    required={required}
                                    itemTemplate={itemTemplate}
                                    valueTemplate={valueTemplate}
                                />
                                <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                            </div>
                            {children !== undefined ? (
                                <div className={'col-4 col-lg-3 col-md-5'}>{children ? children() : null}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;

        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputDropdownComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    enumMode: false,
    filter: false,
    style: null,
    filterBy: 'label',
    insideTable: false,
    placeholder: '',
    rendered: true,
    showClear: false,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'required',
    viewMode: 'VIEW',
};

InputDropdownComponent.propTypes = {
    appendTo: PropTypes.any,
    children: PropTypes.func,
    colClass: PropTypes.string,
    dataKey: PropTypes.string,
    disabled: PropTypes.bool,
    enumName: PropTypes.string,
    enumMode: PropTypes.bool,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    itemTemplate: PropTypes.func,
    label: PropTypes.string,
    labelForValidator: PropTypes.string,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    optionLabel: PropTypes.string,
    optionValue: PropTypes.string,
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    renderValue: PropTypes.func,
    showClear: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    valueTemplate: PropTypes.string,
    valueView: PropTypes.string,
    viewMode: PropTypes.string,
};

export default withTranslation()(InputDropdownComponent);
